<template>
    <div id="dashboard">
        <div class="wrapper">

            <!-- Page Loader -->
            <div class="vld-parent">
                <loading :active.sync="isLoading" :is-full-page="true"></loading>
            </div>

            <navbar :warningBanner="warningBanner"></navbar>

            <sidebar :permissions="permissions" :user="user"></sidebar>

            <!-- Use vuex for state management -->
            <router-view v-if="showPage" @roleUpdated="fetchPermission" @per-page-updated="updateUser" :permissions="permissions" :user="user" :dateFormat="dateFormat"
                :datetimeFormat="datetimeFormat" :editFormInterval="editFormInterval" :decimalDigits="decimalDigits"
                :decimalPoint="decimalPoint" :thousandSeparator="thousandSeparator" :applicationFee="applicationFee" :fullPaymentDiscount="fullPaymentDiscount">
            </router-view>

            <app-footer :appVersion="appVersion"></app-footer>
        </div>
    </div>
</template>

<script>
    import Navbar from './Navbar'
    import Sidebar from './Sidebar'
    import AppFooter from './Footer'

    export default {
        components: {
            Navbar,
            Sidebar,
            AppFooter
        },


        data() {
            return {
                permissions: [],
                user: {},
                editFormInterval: 10000, // 10 sec - recheck currenting editing user interval
                dateFormat: 'DD.MM.YYYY',
                datetimeFormat: 'DD.MM.YYYY HH:mm:ss',
                decimalDigits: 2,
                decimalPoint: '.',
                thousandSeparator: "'",
                applicationFee: 150,
                showPage: false,
                isLoading: true,
                fullPaymentDiscount:5,
                appVersion: null,
                warningBanner: null
            };
        },

        created() {
            this.init();
        },
        methods: {
            /**
             * Initialize Dashboard
             */
            async init() {
                this.setHeaders();

                try {
                    let {data} = await axios.get('/api/user');

                    if (data.id) {
                        this.user = data;
                        this.getConfig();
                        await this.fetchPermission();

                        // render router-view - hot linking fix
                        this.showPage = true;
                        this.isLoading = false;

                        return;
                    }

                    localStorage.removeItem('token');
                    this.$router.go('/login')

                } catch (error) {
                    localStorage.removeItem('token');
                    this.$router.go('/login')
                }
            },

            /**
             * Set general headers for each axios request
             */
            setHeaders() {
                let token = localStorage.getItem('token');
                axios.defaults.headers.common['Content-Type'] = 'application/json';
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            },

            /**
             * Fetch Permissions
             */
            async fetchPermission(value) {
                await axios.get("/api/permissions").then(({
                    data
                }) => this.permissions = data);
            },

            /**
             * Get configuration for app
             */
            async getConfig() {
                let response = await axios.get('/api/config');

                if (response.data) {
                    let config = response.data;
                    if (config.date_format) this.dateFormat = config.date_format;
                    if (config.datetime_format) this.datetimeFormat = config.datetime_format;
                    if (config.decimal_digits) this.decimalDigits = config.decimal_digits;
                    if (config.decimal_point) this.decimalPoint = config.decimal_point;
                    if (config.thousand_separator) this.thousandSeparator = config.thousand_separator;
                    if (config.application_fee) this.applicationFee = config.application_fee;
                    if (config.full_payment_discount) this.fullPaymentDiscount = config.full_payment_discount;
                    if (config.app_version) this.appVersion = config.app_version;
                    if (config.app_env =='test')
                    {
                        this.warningBanner='warningBG'
                    }
                }

                console.log('Warning Banner', this.warningBanner);
            },

            updateUser(perPage) {
                this.user.per_page = perPage;

                axios
                    .put(`/api/users/${this.user.id}`, {user: JSON.stringify(this.user)})
                    .then(response => {
                    });
            }
        },

        // Login Check
        beforeRouteEnter(to, from, next) {
            if (!localStorage.getItem('token')) {
                return next('/login');
            }

            next();
        }
    };

</script>
